export const vQuotes = {
  initial: {
    id: 0,
    lines: [
      "Как жалко..."
    ],
  },
  unlock: {
    id: 1,
    lines: [
      "Приветствую в моей Реальности.",
      "Я удивлён, что тебе удалось достичь её.",
      "Как никак, это моё царство...",
      "Не все так же велики, как я.",
    ],
  },
  realityEnter: {
    id: 2,
    lines: [
      "Удачи с этим!",
      "Она тебе понадобится.",
      "Моя Реальность идеальна. Ты падёшь.",
    ],
  },
  realityComplete: {
    id: 3,
    lines: [
      "Так быстро...",
      "Не думай о себе слишком много.",
      "Это всего лишь начало.",
      "Ты никогда не станешь лучше чем я.",
    ],
  },
  achievement1: {
    id: 4,
    requirement: () => V.spaceTheorems >= 1,
    lines: [
      "Только один? Убожество.",
      "Твои достижения тускнут в сравнении с моими.",
    ],
  },
  achievement6: {
    id: 5,
    requirement: () => V.spaceTheorems >= 6,
    lines: [
      "Это - ничто.",
      "Не будь так доволен собой.",
    ],
  },
  hex1: {
    id: 6,
    requirement: () => player.celestials.v.runUnlocks.filter(a => a === 6).length >= 1,
    lines: [
      "Не думай, что с этого момента будет легче.",
      "Ты слишком горд для такого ничтожного достижения.",
    ],
  },
  achievement12: {
    id: 7,
    requirement: () => V.spaceTheorems >= 12,
    lines: [
      "Как ты...",
      "Это ничего не значит!",
      "Ты никогда не пройдешь их все.",
    ],
  },
  achievement24: {
    id: 8,
    requirement: () => V.spaceTheorems >= 24,
    lines: [
      "Невозможно...",
      "После того, насколько сложными они были для меня...",
    ],
  },
  hex3: {
    id: 9,
    requirement: () => player.celestials.v.runUnlocks.filter(a => a === 6).length >= 3,
    lines: [
      "Нет... Нет... Нет...",
      "Не может быть...",
    ],
  },
  allAchievements: {
    id: 10,
    requirement: () => V.spaceTheorems >= 36,
    lines: [
      "Я... как ты это сделал...",
      "Я столько трудился, чтобы получить их...",
      "Я - величайший...",
      "Нет никого лучше меня...",
      "Никого... Никого... никог-",
    ],
  }
};
